import { FetchAlertQuery } from '@/lib/api/monitoring/alert';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { EnumMonitoringEventType, MonitorAlertEventDto, MonitorAlertFullDto } from './types';

export const useCurrentAlertId = () => {
  const { alertId } = useParams<{ alertId: string }>();

  return String(alertId);
};

const NonAnalyticEvents = new Set([
  EnumMonitoringEventType.CameraOffline,
  EnumMonitoringEventType.CameraOnline,
  EnumMonitoringEventType.CameraTampered,
  EnumMonitoringEventType.CameraFailRecord,
  EnumMonitoringEventType.CameraOverheated,
  EnumMonitoringEventType.CameraTampered,
]);

// Keep stable object reference
const _selectEvents = (data: MonitorAlertFullDto) => {
  const events: MonitorAlertEventDto[] =
    data.events?.filter((event) => {
      if (event.type == null || NonAnalyticEvents.has(event.type)) return false;
      return true;
    }) ?? [];
    
  const sortedEvents = events.sort(
    (a, b) => new Date(a.occurred || 0).getTime() - new Date(b.occurred || 0).getTime()
  );

  return { ...data, events: sortedEvents };
};

export const useCurrentAlert = () => {
  const alertId = useCurrentAlertId();

  return useQuery({
    ...FetchAlertQuery(alertId ?? ''),
    enabled: alertId != null,
    refetchInterval: 7000,
    select: _selectEvents,
  });
};
